<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">
    <div class="vx-navbar-wrapper">
      <vs-navbar id="navbarGlobal" class="vx-navbar navbar-custom" :class="classObj">
        <img height="30" src="@/digicampus/assets/dc-logo-white.svg" />
        <vs-button v-if="$route.name == 'DigiStudentProfile'" icon-pack="feather" icon="icon-arrow-left" class="back_btn__navbar ml-3" @click="$router.back()"><span class="hidden sm:block">BACK</span></vs-button>

        <vs-spacer></vs-spacer>
        
        <feather-icon icon="InfoIcon" class="cursor-pointer sm:mr-6" @click="showDeviceInfo"></feather-icon>
        <feather-icon icon="VideoIcon" class="cursor-pointer sm:mr-6" @click="testSnapshot"></feather-icon>

        <!-- NOTIFICATIONS -->
        <vs-dropdown id="notificationDropdown" ref="notificationDropdown" vs-custom-content vs-trigger-click class="cursor-pointer">
          <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="unreadNotifications.length"></feather-icon>
          <vs-dropdown-menu class="notification-dropdown dropdown-custom">
            <div class="cursor-pointer text-right bg-primary text-white" style="position: absolute; right: 20px; top: 27px; z-index: 99999;">
              <feather-icon @click="refresh" icon="RefreshCwIcon" class="cursor-pointer mb-2"></feather-icon>
            </div>
            <div class="notification-top text-center p-5 bg-primary text-white">
              <h3 class="text-white">{{ unreadNotifications.length }} New</h3>
              <p class="opacity-75">Notification(s)</p>
            </div>

            <VuePerfectScrollbar v-show="unreadNotifications.length > 0" ref="mainSidebarPs" class="vs-con-loading__container scroll-area--nofications-dropdown p-0 mb-10" :settings="settings">
              <ul class="bordered-items">
                <li v-for="ntf in unreadNotifications" :key="ntf.id" class="flex justify-between px-4 py-4 notification cursor-pointer">
                  <div class="flex items-start" @click="handleNtfClick(ntf)">
                    <!-- <feather-icon :icon="ntf.icon" :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon> -->
                    <div class="mx-2">
                      <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.notificationTitle }}</span>
                      <!-- <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.title }}</span> -->
                      <small>{{ ntf.notificationDescription }}</small>
                    </div>
                  </div>
                  <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.createdOn) }}</small>
                  <feather-icon v-show="!showCheck" @mouseover="showCheck = true" id="unReadButton" icon="CircleIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2"></feather-icon>
                  <feather-icon v-show="showCheck" @mouseout="showCheck = false" id="readButton" @click.stop.prevent="markSingleAsRead(ntf.id)" icon="CheckCircleIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2"></feather-icon>
                </li>
              </ul>
            </VuePerfectScrollbar>
            <div v-if="unreadNotifications.length > 0" @click="markAllAsRead" class="
                checkout-footer
                fixed
                pin-b
                rounded-b-lg
                text-primary
                w-full
                p-2
                font-semibold
                text-center
                border
                border-b-0
                border-l-0
                border-r-0
                border-solid
                border-grey-light
                cursor-pointer">
                <span>Mark All as Read</span>
            </div>
          </vs-dropdown-menu>
        </vs-dropdown>
        <!-- USER META -->
        <div class="the-navbar__user-meta flex items-center">
          <div class="text-right leading-tight hidden sm:block">
            <p v-show="showDisplayname" class="font-semibold">{{ user_displayName }}</p>
            <!-- <small>Available</small> -->
          </div>
          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <div class="con-img ml-3">
              <img v-if="activeUserImg.startsWith('http')"
                   key="onlineImg"
                   :src="activeUserImg"
                   alt="user-img"
                   width="40"
                   height="40"
                   class="rounded-full shadow-md cursor-pointer block" />
              <img v-else
                   key="localImg"
                   src="https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png"
                   alt="user-img"
                   width="40"
                   height="40"
                   class="rounded-full shadow-md cursor-pointer block" />
            </div>
            <vs-dropdown-menu>
              <ul style="min-width: 9rem">
                <!-- <li v-show="canChangeSite" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="changeSite">
                  <feather-icon icon="LayersIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">Change Site</span>
                </li>
                <vs-divider class="m-1"></vs-divider> -->
                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.back()">
                  <feather-icon icon="ArrowLeftIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">Back</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <vs-popup id="webcamPopup" title="Live Preview" :active.sync="webcamViewActive">
          <webcam-test v-if="webcamViewActive" />
        </vs-popup>

        <vs-popup id="deviceInfoPopup" title="Device Info" :active.sync="deviceInfoViewActive">
          <device-info v-if="deviceInfoViewActive" />
        </vs-popup>
      </vs-navbar>
    </div>
  </div>
</template>

<script>

import VuePerfectScrollbar from "vue-perfect-scrollbar";
import webcamTest from './WebcamTest.vue';
import deviceInfo from './DeviceInfo.vue';

export default {
  name: "the-navbar",
  components: {
    VuePerfectScrollbar,
    webcamTest,
    deviceInfo
  },
  props: {
    navbarColor: {
      type: String,
      default: "#fff"
    }
  },
  data() {
    return {
      showCheck: false,
      webcamTest: false,
      deviceInfo: false,
      webcamViewActive: false,
      deviceInfoViewActive: false,
      unreadNotifications: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      canChangeSite: false,
      taskDisplayId: "",
      coins: 0,
      showDisplayname: true,

    };
  },
  computed: {
    // HELPER
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.sidebarWidth == "default") return "navbar-default";
      else if (this.sidebarWidth == "reduced") return "navbar-reduced";
      else if (this.sidebarWidth) return "navbar-full";
    },

    // PROFILE
    user_displayName() {
      return JSON.parse(localStorage.getItem("userInfo")).displayName != null ? JSON.parse(localStorage.getItem("userInfo")).displayName.split('(')[0] : JSON.parse(localStorage.getItem("userInfo")).displayName;
    },
    activeUserImg() {
      return (
        JSON.parse(localStorage.getItem("userInfo")).photoURL ||
        this.$store.state.AppActiveUser.img
      );
    }
  },
  methods: {
    handleNtfClick(ntf){
      var self = this;
      var routeData = "";
      self.markSingleAsRead(ntf.id);
      if(ntf.relatedTableName == "CourseTaskLog"){
        if (self.$siteTypeId() == 1) {
          routeData = self.$router.resolve({ path: '/digi/viewassessment', query: { TaskLogId: ntf.key } });
        }
        else {
          routeData = self.$router.resolve({ path: '/viewassessment', query: { TaskLogId: ntf.key } });
        }
        window.open(routeData.href, '_blank');
      }
      else if(ntf.relatedTableName == "Module"){
        self.getModuleStartTask(ntf.key, function() {
          self.getCoins(ntf.userId, ntf.key, function() {
            localStorage.setItem("currentModule", ntf.key);
            self.$router.push({ name: 'StoryViewer', params: { mode: "story", taskDisplayId: self.taskDisplayId, moduleId: ntf.key, isStudent: "true", coins: self.coins } });
            //window.open(routeData.href, '_blank');
          })
        })
      }
      else if(ntf.relatedTableName == "StudentDocument"){
        self.getDocumentUrl(ntf.key);
      }
      else if (ntf.relatedTableName == "MentorSession") {
        self.getMentorSessionData(ntf.key);
      }
      else if(ntf.relatedTableName == "StudentDocumentLogbook"){
        var dropdownEl = document.getElementById("notificationDropdown");
        dropdownEl.click();
        routeData = self.$router.resolve({ path: '/digi/viewprofile', query: { studentDocumentId: ntf.key } });
        window.open(routeData.href, '_self');
      }
        
      //window.open(routeData.href, '_blank');
    },
    getDocumentUrl(id) {
      var self = this;

      var onSuccess = function (response) {
        window.open(response.data, '_blank');
      };

      self.$ajaxGet(self, "Student/GetDocumentUrl/" + id, onSuccess);
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
    },
    closeTab() {
      this.close();
    },
    close() {
      window.open("", "_self").close();
    },
    refresh() {
      this.showLoadingOnElement("mainSidebarPs", 0.75, "material");
      this.getNotifications();
    },
    getModuleStartTask(moduleId, whenDone) {
      var self = this;

      var onSuccess = function (response) {
        self.taskDisplayId = response.data;
        if (whenDone && typeof whenDone == "function")
          whenDone();
      };

      self.$ajaxGet(self, "Module/GetModuleStartTask?moduleId=" + moduleId, onSuccess);
    },
    getCoins(studentId, moduleId, whenDone) {
      var self = this;

      var onSuccess = function (response) {
        self.coins = response.data;
        if (whenDone && typeof whenDone == "function")
          whenDone();
      };

      self.$ajaxGet(self, "CoinTransaction/GetCoins?studentId=" + studentId + "&moduleId=" + moduleId, onSuccess);
    },
    getNotifications() {
      var self = this;
      var onSuccess = response => {
        self.unreadNotifications = response.data;
      };
      var onFinally = response => {
        //self.$vs.loading.close(self.$refs.mainSidebarPs.$el);
      };
      self.$ajaxGet(self, "Notification/GetUnread", onSuccess, onFinally);
    },
    markAllAsRead() {
      var self = this;
      self.showLoadingOnElement("mainSidebarPs", 0.75, "material");
      var data = {
        ids: self.unreadNotifications.map(function(item) { return item.id })
      };
      var onSuccess = response => {
        self.getNotifications();
      };
      self.$ajaxPost(self, "Notification/MarkAllAsRead", data, onSuccess);
    },
    markSingleAsRead(ntfId) {
      var self = this;
      self.showLoadingOnElement("mainSidebarPs", 0.75, "material");
      var onSuccess = response => {
        self.getNotifications();
      };
      self.$ajaxGet(self, "Notification/MarkSingleAsRead/" + ntfId, onSuccess);
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hours " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return (seconds > 50 ? `${seconds} sec ago` : "Just Now");
      }

      return "Just Now";
    },
    testSnapshot() {
      this.webcamViewActive = true;
    },
    showDeviceInfo() {
      this.deviceInfoViewActive = true;
    },
    logout() {
      this.$endUserSession();
      
      let routeData = this.$router.resolve({ path: '/login' });
      window.open(routeData.href, '_self');

      this.$acl.change("");
      localStorage.setItem("permissions", "");
      localStorage.setItem("userSiteInfo", "");
      localStorage.setItem("isStudent", "false");
    },
    changeSite() {
      localStorage.setItem("permissions", "");
      localStorage.setItem("userSiteInfo", "");
      this.$getSites(function() {
        this.$setPermissions(function() {
          this.$acl.change(localStorage.getItem("permissions").split(","));
          this.$router.push("/pages/selectSite");
        });
      });
    },
    getUserSites() {
      var self = this;
      var onSuccess = response => {
        self.canChangeSite = response.data.length == 1 ? false : true;
      };
      self.$ajaxGet(self, "Role/GetSites", onSuccess);
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
  },
  directives: {},
  mounted() {
    var self = this;

    self.getNotifications();
  }
};
</script>
<style lang="scss">
  #deviceInfoPopup div.vs-popup {
    width: 1100px;
  }

  #webcamPopup div.vs-popup {
    width: 715px;
  }

  #notificationDropdown span.feather-icon span.feather-icon-badge {
    background-color: rgba(var(--vs-danger), 1) !important;
  }

  #unReadButton svg.feather.feather.feather-circle {
    position: absolute;
  }

  #readButton svg.feather.feather.feather-check-circle {
    position: absolute;
  }

  #readButton svg.feather.feather.feather-check-circle {
    color: rgb(0, 255, 0);
  }

  #content-area {
    margin-left: 0px;
  }

  .main-menu-sidebar .vs-sidebar.vs-sidebar-reduce {
    max-width: 80px !important;
  }

  .vs-sidebar.vs-sidebar-reduce:hover:not(.vs-sidebar-reduceNotHoverExpand) {
    max-width: 80px !important;
  }

  .back_btn__navbar {
    border-radius: 45px;
    font-size: 16px !important;
    padding: .75rem 1rem !important;

    .vs-icon {
      font-size: 1.4rem !important;
    }

    @media screen and (max-width: 575px) {
      i {
        margin-right: 0px !important;
      }
    }

    @media screen and (min-width: 576px) {
      i {
        margin-right: 11px !important;
      }
    }
  }

  .help_btn__navbar {
    border-radius: 45px;
    font-size: 16px !important;
    padding: .75rem 1rem !important;

    .vs-icon {
      font-size: 1.4rem !important;
    }
  }
  .home_btn__navbar {
    border-radius: 45px;
    font-size: 16px !important;
    padding: .75rem 1rem !important;

    .vs-icon {
      font-size: 1.4rem !important;
    }
  }
</style>
